<template>
  <div class="sidebar" id="sidebar">
    <div class="sidebar-inner slimscroll">
      <div id="sidebar-menu" class="sidebar-menu">
        <ul>
          <li>
            <router-link to="/"
              ><i class="la la-home"></i> <span>Back to Home</span></router-link
            >
          </li>

          <li class="menu-title" v-can="{ any: ['VIETBAI_VIEW'] }">
            <span>Quản lý đăng bài</span>
          </li>

          <li v-can="{ any: ['VIETBAI_VIEW'] }">
            <router-link to="/dashboard-viet-bai-user">
              <i class="la la-user-circle"></i>
              <span>Thống kê bài viết của tôi</span>
            </router-link>
          </li>
          <li v-can="{ any: ['VIETBAI_VIEW'] }">
            <router-link to="/dashboard-viet-bai-admin">
              <i class="la la-bar-chart"></i>
              <span>Thống kê bài viết website</span>
            </router-link>
          </li>
          <li v-can="{ any: ['VIETBAI_VIEW'] }">
            <router-link to="/ai-writer">
              <i class="la la-magic"></i>
              <span>Viết bài thông minh</span>
            </router-link>
          </li>
          <li v-can="{ any: ['VIETBAI_VIEW'] }">
            <router-link to="/viet-bai-hang-loat">
              <i class="la la-clone"></i>
              <span>Viết bài hàng loạt</span>
            </router-link>
          </li>

          <li class="menu-title" v-can="{ any: ['WPSITE_VIEW', 'CTA_VIEW'] }">
            <span>Quản lý website</span>
          </li>

          <li v-can="{ any: ['WPSITE_VIEW'] }">
            <router-link to="/website-list">
              <i class="la la-globe"></i>
              <span>Danh sách website</span>
            </router-link>
          </li>
          <li v-can="{ any: ['WPSITE_VIEW'] }">
            <router-link to="/blog-on-website-list">
              <i class="la la-list-alt"></i>
              <span>Bài viết trong website</span>
            </router-link>
          </li>
          <li v-can="{ any: ['CTA_VIEW'] }">
            <router-link to="/cta-list">
              <i class="la la-mouse-pointer"></i>
              <span>Danh sách CTA</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// SỬA LỖI: Đây là script cho Sidebar, không phải Header
export default {
  name: "SidebarAppComponent", // 1. Sửa tên component
  data() {
    return {
      // Dữ liệu của component
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (window.$) {
        if ($("html").hasClass("menu-opened")) {
          $("html").removeClass("menu-opened");
          $(".sidebar-overlay").removeClass("opened");
          $(".main-wrapper").removeClass("slide-nav");
          $("#task_window").removeClass("opened");
        }
        $(document).ready(() => {
          this.initializeLayoutPlugins();
        });
      } else {
        console.error(
          "jQuery is not loaded. Layout plugins cannot be initialized."
        );
      }
    });
  },
  beforeUnmount() {
    // Dọn dẹp tất cả trình lắng nghe sự kiện toàn cục
    if (window.$) {
      $(document).off("click", "#toggle_btn");
      $(document).off("click", "#mobile_btn");
      $(".sidebar-overlay").off("click").remove();
      $("#sidebar-menu a").off("click");
      $(window).off("resize.slimscroll");
      $(window).off("resize.pagewrapper");

      // Dọn dẹp trình hover (QUAN TRỌNG)
      $(document).off("mouseenter mouseleave", ".sidebar");
    }
  },
  methods: {
    initializeLayoutPlugins() {
      // === KHAI BÁO BIẾN ===
      var $wrapper = $(".main-wrapper");
      var $pageWrapper = $(".page-wrapper");
      var $slimScrolls = $(".slimscroll");

      // === THIẾT LẬP TRẠNG THÁI BAN ĐẦU ===
      // Buộc sidebar ở trạng thái MỞ RỘNG (ghim) khi tải trang
      if (
        !$("body").hasClass("mini-sidebar") &&
        !$("body").hasClass("sidebar-pinned")
      ) {
        $("body").addClass("sidebar-pinned"); // GHIM nó lại
        console.log("Forcing pinned sidebar on initial load.");
      }

      // === 1. KHỞI TẠO SLIMSCROLL ===
      if ($slimScrolls.length > 0) {
        $(window).off("resize.slimscroll");

        function handleSlimscrollResize() {
          try {
            var $headerHeight = $(".header").height() || 60;
            var wHeight = $(window).height() - $headerHeight;
            $slimScrolls.height(wHeight);
            $(".sidebar .slimScrollDiv").height(wHeight);
          } catch (e) {
            console.error("Error resizing slimscroll:", e);
          }
        }

        try {
          if (typeof $.fn.slimScroll === "function") {
            $slimScrolls.slimScroll({
              height: "auto",
              width: "100%",
              position: "right",
              size: "7px",
              color: "#ccc",
              wheelStep: 10,
              touchScrollStep: 100,
            });

            handleSlimscrollResize();
            $(window).on("resize.slimscroll", handleSlimscrollResize);
          } else {
            console.warn(
              "jQuery SlimScroll plugin is not loaded. Using native CSS scroll."
            );
            var $headerHeight = $(".header").height() || 60;
            var wHeight = $(window).height() - $headerHeight;
            $slimScrolls.css({
              "overflow-y": "auto",
              height: wHeight + "px",
            });
            $(window).on("resize.slimscroll", function () {
              var newHeight =
                $(window).height() - ($(".header").height() || 60);
              $slimScrolls.css("height", newHeight + "px");
            });
          }
        } catch (e) {
          console.error("Error initializing slimScroll: ", e);
        }
      }

      // === 2. SET MIN-HEIGHT CHO PAGE WRAPPER ===
      try {
        $(window).off("resize.pagewrapper");
        function handlePageWrapperResize() {
          var pHeight = $(window).height();
          $pageWrapper.css("min-height", pHeight);
        }
        handlePageWrapperResize();
        $(window).on("resize.pagewrapper", handlePageWrapperResize);
      } catch (e) {
        console.error("Error setting pageWrapper min-height: ", e);
      }

      // === 3. KHỞI TẠO CÁC PLUGIN UI KHÁC ===
      try {
        if ($.fn.tooltip && $('[data-toggle="tooltip"]').length > 0) {
          $('[data-toggle="tooltip"]').tooltip();
        }
      } catch (e) {
        console.warn("Tooltip init failed.", e);
      }

      try {
        if ($.fn.select2 && $(".select").length > 0) {
          $(".select").select2({
            minimumResultsForSearch: -1,
            width: "100%",
          });
        }
      } catch (e) {
        console.warn("Select2 init failed.", e);
      }

      try {
        if ($.fn.datetimepicker && $(".datetimepicker").length > 0) {
          $(".datetimepicker").datetimepicker({
            format: "DD/MM/YYYY",
            icons: {
              up: "fa fa-angle-up",
              down: "fa fa-angle-down",
              next: "fa fa-angle-right",
              previous: "fa fa-angle-left",
            },
          });
        }
      } catch (e) {
        console.warn("Datetimepicker init failed.", e);
      }

      // === 4. LOGIC NÚT "GHIM" (PIN) SIDEBAR ===
      $(document)
        .off("click", "#toggle_btn")
        .on("click", "#toggle_btn", function (e) {
          e.preventDefault();

          if ($("body").hasClass("mini-sidebar")) {
            // --- ĐANG THU NHỎ, CLICK ĐỂ "GHIM" MỞ RỘNG ---
            $("body").removeClass("mini-sidebar");
            $wrapper.removeClass("mini-sidebar");
            $("body").addClass("sidebar-pinned"); // Thêm class "ghim"

            // Khôi phục trạng thái menu con
            $("#sidebar-menu .submenu > ul").hide();
            $("#sidebar-menu li a.subdrop").next("ul").show();
          } else {
            // --- ĐANG MỞ RỘNG (HOẶC ĐANG GHIM), CLICK ĐỂ BỎ GHIM VÀ THU NHỎ ---
            $("body").removeClass("sidebar-pinned"); // Bỏ class "ghim"
            $("body").addClass("mini-sidebar");
            $wrapper.addClass("mini-sidebar");

            // Dọn dẹp style
            $("#sidebar-menu .submenu > ul").removeAttr("style");
            $("#sidebar-menu a").removeClass("subdrop");
          }
        });

      // === 5. XỬ LÝ SUBMENU CLICK (ĐÃ SỬA LỖI MOBILE) ===
      $("#sidebar-menu a")
        .off("click")
        .on("click", function (e) {
          var $this = $(this);
          var $parentLi = $this.parent();

          if ($parentLi.hasClass("submenu")) {
            // Đây là link cha (ví dụ: "Dashboard", "Ứng dụng")
            e.preventDefault();

            // CHỈ chạy animation slide KHI sidebar đang MỞ RỘNG (desktop)
            if (!$("body").hasClass("mini-sidebar")) {
              if (!$this.hasClass("subdrop")) {
                $("ul", $this.parents("ul:first")).slideUp(350);
                $("a", $this.parents("ul:first")).removeClass("subdrop");
                $this.next("ul").slideDown(350);
                $this.addClass("subdrop");
              } else if ($this.hasClass("subdrop")) {
                $this.removeClass("subdrop");
                $this.next("ul").slideUp(350);
              }
            }
          } else {
            // --- (FIX MỚI) ĐÂY LÀ LINK CON (router-link) ---
            // Tự động đóng menu mobile khi click vào link con
            // Chúng ta kiểm tra 'menu-opened' là class an toàn nhất cho biết mobile menu đang mở
            if ($("html").hasClass("menu-opened")) {
              $("html").removeClass("menu-opened");
              $(".sidebar-overlay").removeClass("opened");
              $(".main-wrapper").removeClass("slide-nav");
              $("#task_window").removeClass("opened");
            }
          }
        });

      // Khởi tạo active link (chỉ khi không ở mini-sidebar)
      if (!$("body").hasClass("mini-sidebar")) {
        $("#sidebar-menu ul li.submenu a.active")
          .parents("li.submenu:last")
          .children("a:first")
          .addClass("subdrop")
          .next("ul")
          .show();

        $("#sidebar-menu ul li a.active")
          .parents("li.submenu")
          .children("a:first")
          .addClass("subdrop");
      }

      // === 6. LOGIC HOVER ĐỂ MỞ RỘNG/THU NHỎ ===
      $(document).off("mouseenter mouseleave", ".sidebar");

      $(document).on("mouseenter", ".sidebar", function () {
        // CHỈ chạy khi sidebar KHÔNG BỊ GHIM và đang ở chế độ MINI
        if (
          !$("body").hasClass("sidebar-pinned") &&
          $("body").hasClass("mini-sidebar")
        ) {
          // --- MỞ RỘNG SIDEBAR ---
          $("body").removeClass("mini-sidebar");
          $wrapper.removeClass("mini-sidebar");

          // Khôi phục trạng thái menu con
          $("#sidebar-menu .submenu > ul").hide();
          $("#sidebar-menu li a.subdrop").next("ul").show();
        }
      });

      $(document).on("mouseleave", ".sidebar", function () {
        // CHỈ chạy khi sidebar KHÔNG BỊ GHIM và KHÔNG ở chế độ MINI
        if (
          !$("body").hasClass("sidebar-pinned") &&
          !$("body").hasClass("mini-sidebar")
        ) {
          // --- THU NHỎ SIDEBAR VỀ LẠI ---
          $("body").addClass("mini-sidebar");
          $wrapper.addClass("mini-sidebar");

          // Dọn dẹp style
          $("#sidebar-menu .submenu > ul").removeAttr("style");
          $("#sidebar-menu a").removeClass("subdrop");
        }
      });

      // === 7. MOBILE SIDEBAR (Giữ nguyên) ===
      if ($(".sidebar-overlay").length === 0) {
        $("body").append('<div class="sidebar-overlay"></div>');
      }

      $(document)
        .off("click", "#mobile_btn")
        .on("click", "#mobile_btn", function () {
          $wrapper.toggleClass("slide-nav");
          $(".sidebar-overlay").toggleClass("opened");
          $("html").addClass("menu-opened");
          $("#task_window").removeClass("opened");
          return false;
        });

      $(".sidebar-overlay")
        .off("click")
        .on("click", function () {
          $("html").removeClass("menu-opened");
          $(this).removeClass("opened");
          $wrapper.removeClass("slide-nav");
          $(".sidebar-overlay").removeClass("opened");
          $("#task_window").removeClass("opened");
        });
    },
  },
};
</script>

<style scoped>
/* Thêm CSS fallback cho slimscroll nếu plugin không được tải */
.sidebar-inner.slimscroll {
  height: 100%;
  /* Fallback nếu slimscroll không tải được */
  overflow-y: auto;
}
.mini-sidebar .menu-title {
  display: none;
}
</style>
